export var sendingDomainUri = 'sendingDomain';
export var sendingDomainsUri = 'sendingDomains';
export var emailNotificationUri = 'emailNotifications';
export var createEmailDomainApi = function (baseUrl, http) {
    var newSendingDomainApi = {
        getAllSendingDomains: function () { return http.get("".concat(baseUrl, "/").concat(sendingDomainsUri)); },
        getSendingDomain: function (id) { return http.get("".concat(baseUrl, "/").concat(sendingDomainsUri, "/").concat(id)); },
        addSendingDomain: function (domain) { return http.post("".concat(baseUrl, "/").concat(sendingDomainsUri), { domain: domain }); },
        deleteSendingDomain: function (id) { return http.delete("".concat(baseUrl, "/").concat(sendingDomainsUri, "/").concat(id)); },
        validateSendingDomain: function (id) { return http.get("".concat(baseUrl, "/").concat(sendingDomainsUri, "/").concat(id, "/isValid")); },
        setDefaultSendingDomain: function (id) { return http.post("".concat(baseUrl, "/").concat(sendingDomainsUri, "/").concat(id, "/default"), {}); },
        editSendingDomain: function (dto) { return http.post("".concat(baseUrl, "/").concat(sendingDomainsUri, "/").concat(dto.id, "/edit"), dto); },
    };
    return {
        getCustomSendingDomain: function () {
            return http.get("".concat(baseUrl, "/").concat(emailNotificationUri, "/").concat(sendingDomainUri));
        },
        setCustomSendingDomain: function (domainName) {
            return http.post("".concat(baseUrl, "/").concat(emailNotificationUri, "/").concat(sendingDomainUri, "?domain=").concat(domainName), {});
        },
        validateCustomSendingDomain: function () {
            return http.post("".concat(baseUrl, "/").concat(emailNotificationUri, "/").concat(sendingDomainUri, "/validate"), {});
        },
        deleteCustomSendingDomain: function () {
            return http.delete("".concat(baseUrl, "/").concat(emailNotificationUri, "/").concat(sendingDomainUri));
        },
        sendingDomains: newSendingDomainApi,
    };
};
//# sourceMappingURL=index.js.map